import type { IAuthToken, IUserProfile } from '../../../../redux/api/types'
import { useSelector } from 'react-redux'
import { LINKS } from '../../../../utils/constants/links'

export interface INavConfig {
  title: string
  path: string
}

function navConfigMyWebsite (): INavConfig[] {
  const user: IUserProfile = useSelector((state: any) => state.userState.user)
  const authToken: IAuthToken = useSelector((state: any) => state.userState.authToken)
  return [
    {
      title: 'Edit My Website',
      path: user?.account.websiteUrl ? `${String(user.account.websiteUrl)}/wp-admin/?email=${String(authToken?.login)}&token=${String(authToken?.token)}` : LINKS.MANAGE_WEBSITE
    }
  ]
}

export default navConfigMyWebsite
